<style lang="scss" scoped>
.skc-detail {
  width: 702px;
  margin: 24px auto;
  .brand {
    margin: 24px 0;
    .name {
      color: #1d1d1d;
      font-size: 34px;
      line-height: 30px;
    }
    .detail {
      margin-top: 8px;
      max-height: 80px;
      overflow: hidden;
      font-size: 28px;
      line-height: 40px;
    }
  }

}
  .split-line {
    width: 702px;
    height: 2px;
    margin: 0 auto;
    box-sizing: border-box;
    border: 1px solid rgba(#1d1d1d, 0.06);
  }
</style>
<template>
  <div class="skc-detail">
    <div class="brand">
      <div class="name">{{brandInfo.brandEnName || '未知款式'}}</div>
      <div class="detail">{{brandInfo.productName}}</div>
    </div>
  </div>
</template>
<script>
export default {
  props: {
    brandInfo: {
      default: () => {
        return {}
      } 
    }
  },
  data () {
    return {
      brandName: 'LOUIS VUTTON 路易威登',
      desp: 'GUCCI 20春夏女士Sylvie 1969系列小号肩背包GUCCI 20春夏女士Sylvie 1969系列小号肩背包GUCCI 20春夏女士Sylvie 1969系列小号肩背包GUCCI 20春夏女士Sylvie 1969系列小号肩背包'
    }
  },
  methods: {}
}
</script>
